import {Component, computed, input, OnInit, output} from "@angular/core";
import {Assessable, AssessableItem, AssessableItemGroup} from "@models";
import {Translations, TranslationToken} from "@translations";
import {SafeHtmlComponent} from "../../safe-html/safe-html.component";
import {AssessablePanelType, isAssessableGroupActive} from "@common/components/assessment/utils";
import {zoomInOnEnterAnimation, zoomOutOnLeaveAnimation} from "angular-animations";
import {GeneratedTypePredicates} from "@services";

const localizationKeyPrefixMap = {
	[AssessablePanelType.Checklist]: "CHECKLIST",
	[AssessablePanelType.Assessment]: "ASSESSMENT",
} as const;

@Component({
	selector: "sim-assessable-admin-index",
	templateUrl: "./assessable-admin-index.component.html",
	styleUrls: ["./assessable-admin-index.component.scss"],
	animations: [zoomInOnEnterAnimation({duration: 250}), zoomOutOnLeaveAnimation({duration: 250})],
	providers: [SafeHtmlComponent],
	standalone: false,
})
export class AssessableAdminIndexComponent implements OnInit {
	protected readonly T = Translations;
	protected readonly Array = Array;
	protected readonly AssessablePanelType = AssessablePanelType;
	protected readonly GeneratedTypePredicates = GeneratedTypePredicates;

	activeItemId = input.required<string>();
	activeGroupId = input.required<string>();
	assessable = input.required<Assessable<AssessableItem>>();
	type = input.required<AssessablePanelType>();
	errorIds = input<string[]>([]);
	showConditionalGroups = input<boolean>(true);
	showImportedItems = input<boolean>(false);

	onItemClicked = output<{
		groupId: string | null;
		itemId: string;
	}>();
	onGroupClicked = output<string>();

	protected isUngroupedItemGroupActive = computed(() => {
		return this.assessable().ungroupedItems.some((item) => item.assessableItemId === this.activeItemId());
	});

	protected nonGroupedItemsHeaderLocalizationKey: TranslationToken = "" as TranslationToken;

	public ngOnInit() {
		const prefix = localizationKeyPrefixMap[this.type()];
		this.nonGroupedItemsHeaderLocalizationKey = `${prefix}_PANEL_NON_GROUPED_ITEMS_HEADER`;
	}

	protected isGroupVisible(group: AssessableItemGroup<AssessableItem>): boolean {
		if (group?.items.length === 0) {
			return false;
		}

		if (this.showConditionalGroups()) {
			return true;
		}

		return isAssessableGroupActive(group.groupId, this.assessable());
	}

	protected onItemClickedHandler(eventData: {groupId: string; itemId: string}): void {
		this.onItemClicked.emit(eventData);
	}

	protected onGroupClickedHandler(groupId: string): void {
		this.onGroupClicked.emit(groupId);
	}

	protected onUngroupedGroupClicked(): void {
		if (this.assessable().ungroupedItems.length <= 0) {
			return;
		}
		const itemId = this.assessable().ungroupedItems[0].assessableItemId;
		this.onItemClicked.emit({groupId: null, itemId});
	}
}
